import React, { useEffect, useState } from 'react'
import { SelectModalPc } from '../Common/SelectModalPc'
import { useSearchConditionPc } from '../hooks/useSearchCondition'
import { GoodsItem, GoodsListParams, serviceGoodsList, serviceStaffs } from '../services/common/filter'
import { LabeledValue, SelectProps } from 'antd/es/select';
import { isError } from '@/component/common/error';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { DhbFilterForm, DhbFooterProps } from '@/component/PageComponent/PageComponent';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { Button, Col, Pagination, Row, Flex } from 'antd';
import { TableFieldSetColumn } from '@/component/Report/TableFieldSet/TableFieldSet';
import { useSelectModalList } from '../hooks/useSelectModalList';
import { FilterTypes } from '../../FilterCommon/Filter';

type FilterParams = Partial<{
    page: number;
    pageSize: number;
    isCustomize: true;
    kw?:string
}>;

const initParams: FilterParams = {
    page: 1,
    pageSize: 10,
    isCustomize: true,
};

const DhbFooter = (
    props: DhbFooterProps & { onCancel(): void; onOk(): void },
  ) => {
    const {
      selectedRowKeys = [],
      onChange,
      dataSource = [],
      isAllSelect,
      total = 0,
      pageInfo,
      toggleSelectRowKeys,
    } = props;
    const { page = 1, pageSize = 10 } = pageInfo;
  
    return (
      <div style={{ padding: '10px' }}>
        <Row>
          <Col span={14}>
            <Pagination
              style={{ textAlign: 'left' }}
              defaultPageSize={pageSize}
              total={total}
              current={page}
              onChange={(page, pageSize) => onChange({ page: page, pageSize })}
              onShowSizeChange={(current, pageSize) =>
                onChange({ page: 1, pageSize })
              }
              showQuickJumper={false}
            />
          </Col>
          <Col span={10}>
            <div style={{ textAlign: 'right' }}>
              <Button
                onClick={() => props.onCancel()}
                style={{ margin: '0 10px' }}
              >
                取消
              </Button>
              <Button type="primary" onClick={() => props.onOk()}>
                确定
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

const getColumns = (isAiChat?: boolean):TableFieldSetColumn[] => {
    const baseColumns:TableFieldSetColumn[] = [
        {
            width: 50,
            dataIndex: 'sequence',
            render: (text:string, record:GoodsItem, index:number) => {
                return index + 1;
            }
        },
        {
            width: '15%',
            title: '商品编号',
            dataIndex: 'goods_num'
        },{
            width: '20%',
            title: '商品名称',
            dataIndex: 'goods_name'
        },{
            width: '15%',
            title: '品牌',
            dataIndex: 'brand_name'
        },{
            width: '10%',
            title: '可售库存',
            dataIndex: 'available_number'
        },{
            width: '10%',
            title: '订货价',
            dataIndex: 'whole_price'
        },{
            title: '进货价',
            dataIndex: 'purchase_price'
        },{
            title: '单位',
            dataIndex: 'base_units'
        },{
            title: '规格',
            dataIndex: 'price_count',
            render: (text:string) => {
                return text + '种'
            }
        },{
            title: '上下架',
            dataIndex: 'putaway',
            render: (putaway: string) => {
                return putaway == 'T' ? '上架' : '下架'
            }
        }
    ];

    if (isAiChat) {
        // 当 isAiChat 为 true 时，过滤掉可售库存、订货价、进货价、上下架字段
        return baseColumns.filter(column => 
            !['available_number', 'whole_price', 'purchase_price', 'putaway'].includes(column.dataIndex as string)
        );
    }

    return baseColumns;
};


const listKey = 'goods_id';
interface StaffListModalProps {
    onChangeValues(values:string[],options: LabeledValue[],dataSource:GoodsItem[]):void;
    onClose(): void;
    type: 'radio' | 'checkbox';
    source_company_id?:number //运营商公司id
    collaborator_id?:number //当前公司id
    isAiChat?: boolean //是否为AI聊天模式
}
const GoodsListModal = (props: StaffListModalProps) => {
    const { source_company_id,collaborator_id, isAiChat } = props
    const [goods, setGoods] = React.useState<GoodsItem[]>([]);
    const [count, setCount] = React.useState<number>(0);
    const getGoods = async (params: FilterParams) => {
        let res = await serviceGoodsList({...params, source_company_id,collaborator_id });
        if (isError(res)) {
            return;
        }
        let data = res.data.list;
        setGoods(data);
        setCount(res.data.count);
    };
    let { setParams, setPageInfo, loading, pageInfo, params } = useGetData({
        getData: getGoods,
        defaultParams: initParams,
    });
    const { selectedRowKeys, isAllSelect, toggleSelectRowKeys, setSelectedRowKeys, } = useSelectRow(goods, listKey);
    React.useEffect(() => {
        getGoods({ ...params, ...pageInfo });
    }, []);
    return (
        <Flex vertical style={{height: '100%'}}>
            <h2 style={{ paddingLeft: '16px',margin:'16px 0 0 0' }}>选择商品</h2>
            <DhbFilterForm
                defaultParams={initParams}
                loading={loading}
                onSearch={(params) => setParams(params)}
                filterProps={{
                    filters: [
                        {
                            type: FilterTypes.Input,
                            dataIndex: 'kw',
                            placeholder: '名称/首字母拼音/编号',
                        },
                        {
                            type: FilterTypes.GoodsCategory,
                            dataIndex: 'category_id',
                            placeholder:'商品分类',
                            mode:'tags'
                            
                        },
                        {
                            type: FilterTypes.GoodsBrand,
                            dataIndex: 'brand_id',
                            placeholder:'商品品牌',
                            mode:undefined
                        },
                        {
                            type: FilterTypes.GoodsType,
                            dataIndex: 'goods_type',
                            placeholder:'商品标识',
                            mode:undefined
                        },
                        {
                            type: FilterTypes.PutAway,
                            dataIndex: 'putaway',
                            placeholder:'上下架',
                            mode:undefined
                        },
                    ],
                }}
            />
            <TableResize
                style={{ flex: 1, padding: '0 20px 16px 16px' }}
                rowKey={listKey}
                pagination={false}
                columns={getColumns(isAiChat)}
                dataSource={goods}
                rowSelection={{
                    type: props.type,
                    selectedRowKeys: selectedRowKeys,
                    onChange: (keys) => {
                        setSelectedRowKeys(keys as any);
                    },
                }}
                size="middle"
            />
            <DhbFooter
                selectedRowKeys={selectedRowKeys}
                dataSource={goods}
                isAllSelect={isAllSelect}
                toggleSelectRowKeys={toggleSelectRowKeys}
                onChange={(pageInfo) => {
                    setPageInfo(pageInfo);
                }}
                total={count}
                pageInfo={pageInfo}
                onCancel={() => {
                    props.onClose();
                }}
                onOk={() => {
                    props.onClose();
                    let selectedRow: GoodsItem[] = [];
                    goods.forEach((item) => {
                        // let a = item[listKey];
                        if (selectedRowKeys.includes(item[listKey])) {
                            selectedRow.push(item);
                        }
                    });
                    let options= selectedRow.map(item => ({label:item.goods_name,value:item.goods_id}))
                    props.onChangeValues &&
                        props.onChangeValues(selectedRowKeys,options, selectedRow);
                }}
            />
        </Flex>
    );
};

export interface FilterSelectGoodsPcProps extends SelectProps{
    collaborator_company_id?:number //运营商公司id
    company_id?:number //当前公司id
    isAiChat?: boolean //是否为AI聊天模式

}

function FilterSelectGoodsPc(props: FilterSelectGoodsPcProps) {
    const { placeholder = '选择商品', value, mode = 'multiple' , collaborator_company_id:source_company_id,company_id:collaborator_id, isAiChat, ...rest } = props
    // const [goodsList, setGoodsList] = useState<GoodsItem[]>([])
    const { list:goodsList, setList:setGoodsList,prependList } = useSelectModalList<GoodsItem>({listKey:"goods_id",componentKey:'FilterSelectGoodsPc',value:props.value})

    const [isFirstFocus,setIsFirstFocus] = useState<boolean>(true) 
    const [loading,setLoading] = useState<boolean>(false)
    // const [values, setValues] = useState<string | string[]>(value)
    const filterGoods = async (params: FilterParams) => {
        setLoading(true)
        const goodsData = await serviceGoodsList({...params,source_company_id,collaborator_id,})
        // const filterData = goodsData.data&&goodsData.data.list.map((goods:GoodsItem) => {
        //     return {
        //         label: goods.goods_name,
        //         value: goods.goods_id,
        //         key: goods.goods_id
        //     }
        // })
        setLoading(false)
        setGoodsList(goodsData.data?.list ||[])
    }
 
    let onChange: Required<SelectProps>['onChange'] = (value, option) => {
        props.onChange && props.onChange(value, option)
    };
    const focus =()=>{
        if(isFirstFocus){
            if(!goodsList.length){
                setLoading(true)
                filterGoods({
                    page: 0,
                    pageSize: 10,
                    isCustomize: true,
                })
            }
            setIsFirstFocus(false)
        }
        
    }
    return (
        <div>
        <SelectModalPc
            mode={mode}
            value={value}
            placeholder={placeholder}
            options={goodsList.map(item =>({label: item.goods_name, value: item.goods_id}))}
            onFocus={focus}
            loading={loading}
            onChange={(value, option) => {
                onChange && onChange(value, option);
            }}
            onSearch={(kw)=>{
                filterGoods({
                    page: 0,
                    pageSize: 10,
                    isCustomize: true,
                    kw: kw,
                })
            }}
            MoreComponent={({ onClose }) => (
                <GoodsListModal
                    type={mode=='multiple'?'checkbox':'radio'}
                    onClose={onClose}
                    source_company_id={ source_company_id} //运营商公司id
                    collaborator_id={ collaborator_id} //当前公司id
                    isAiChat={isAiChat} //是否为AI聊天模式
                    onChangeValues={(values,option,sources)=>{
                        prependList(sources)
                        onChange(values,option)
                    }}
                />
            )}
            {...rest}
       />
       </div>

    )
}

export default FilterSelectGoodsPc